// extracted by mini-css-extract-plugin
export var logo = "_4p-2";
export var logoWrapper = "_4p-1";
export var strip = "_4p-0";